export default {
  getCompanyRestaurantsMapping: 'GET_COMPANY_RESTAURANTS_MAPPINGS',
  getCompanyRestaurantsMappingSuccess: 'GET_COMPANY_RESTAURANTS_MAPPING_SUCCESS',
  getCompanyRestaurantsMappingFailed: 'GET_COMPANY_RESTAURANTS_MAPPING_FAILED',
  updateCompanyRestaurantsMapping: 'UPDATE_COMPANY_RESTAURANTS_MAPPING',
  updateCompanyRestaurantsMappingSuccess: 'UPDATE_COMPANY_RESTAURANTS_MAPPING_SUCCESS',
  updateCompanyRestaurantsMappingFailed: 'UPDATE_COMPANY_RESTAURANTS_MAPPING_FAILED',
  resetToInitialState: 'COMPANY_RESTAURANT_RESET_TO_INITIAL_STATE',
};
